// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"72269a31e6e83bdf717b","293":"139587a3bd054e3607da","518":"2d30647620a4d7e78bd0","779":"fe3cfa1d87191ca9a0f9"}[chunkId] + ".js";
};